module.exports = __webpack_public_path__ + "img/Alchimeia.695eea5c.png";